import { getAxiosInstance } from "../ApiConfig";

async function FetchAllApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllApprovalRuleByUserId`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllSharedApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedApproval`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalMyList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRequestorApprovals`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalSharedList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllApproverApprovals`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByApprovalRuleId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkConnection(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/checkConnectionForApprovalQueue/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ruleSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createApprovalRule`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateApprovalRule/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateRulesforMine(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/removeUserFromAutomationRule/${automationId}/${action}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateRulesStatus(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateBusinessRuleForAutomationStatus/${automationId}/${action}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRuleId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteApprovalRule/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function SaveApprovalQueue(status, id, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/approvalProcessFunctionality/${status}/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function QueueDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getApprovalProcessMstDetaiPage/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRequestId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteApprovalApprovalProcessRequest/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function addCommentsForApprovalProcess(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/addCommentsForApprovalProcess/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllApprovals,
    ruleDetailData,
    ruleSave,
    ruleUpdate,
    addCommentsForApprovalProcess,
    deleteRuleId,
    FetchAllApprovalMyList,
    FetchAllApprovalSharedList,
    SaveApprovalQueue,
    FetchAllSharedApprovals,
    QueueDetails,
    deleteRequestId,
    updateRulesforMine,
    updateRulesStatus,
    checkConnection,
}